import { render, staticRenderFns } from "./IncomingCard.vue?vue&type=template&id=53b3a5fd"
import script from "./IncomingCard.vue?vue&type=script&lang=js"
export * from "./IncomingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports